import { useEffect, useState } from "react";
import AmrMeterGroup from "../amr-meter-group/amr-meter-group";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import StockTable from "../stock-table/stock-table";
import UpperControls from "../upper-controls/upper-controls";
import "./stock-management.scss";
import { useDispatch, useSelector } from "react-redux";
import NewFlavorsPopup from "../new-flavors-popup/new-flavors-popup";
import { deleteICProductsByShop, getICProductsByShop, updateICProductsByShop, updateICProductsByShopBulk } from "../../productSlices";
import ConfirmationPopup from "../confirmation-popup/confirmation-popup";
import { Button } from "primereact/button";
import { Dropdown } from 'primereact/dropdown';
import { setSelectedShop } from "features/authentication/userSlices";
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import { StockDestination } from "../stock-table-count-cell/stock-table-count-cell";
const StockManagement = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null)
  const [wordToConfirm, setWordToConfirm] = useState(null)
  const [productIdToDelete, setProductIdToDelete] = useState(null)
  const ic_products = useSelector((state: any) => state.product.ic_products);
  const selectedShop = useSelector((state: any) => state.user.selectedShop);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [search, setSearch] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const uniqueProductNames = Array.from(new Set(ic_products.map(product => product.name as string)));
  const selectedShopObject = user.shops.find(shop => shop.id === selectedShop);
  const [modifiedProducts, setModifiedProducts] = useState([]);
  const global_three_liter = ic_products.reduce((accumulator ,item) => {
    return accumulator += item.three_liter;
    }, 0)
const global_five_liter = ic_products.reduce((accumulator ,item) => {
    return accumulator += item.five_liter;
    }, 0)
const global_seven_liter = ic_products.reduce((accumulator ,item) => {
    return accumulator += item.seven_liter;
    }, 0)

  const meterGroupValues = [{ label: '7L pack', value: global_seven_liter, color: '#5FC9CA' }, { label: '5L pack', value: global_five_liter, color: '#6C1EF269' }, { label: '3L pack', value: global_three_liter, color: '#6B18C33B' }];
  useEffect(()=>{
    dispatch(getICProductsByShop(selectedShop))
  },[selectedShop])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    setModifiedProducts(ic_products);
  }, [ic_products]);
  useEffect(() => {
    if (ic_products.length > 0) {
      setSelectedFilters(Array.from(new Set(ic_products.map(product => product.name as string))));
    }
  }, [ic_products]);

  const shopTemplate = (option) => {
    if (!option) return null;
    
    return (
      <div className="mobile-shop-selector__option">
        <div className="mobile-shop-selector__option__name">{option.name}</div>
        <div className="mobile-shop-selector__option__address">{option.address}</div>
      </div>
    );
  };

  const handleFilterToggle = (productName: string) => {
    setSelectedFilters(prev => 
      prev.includes(productName) 
        ? prev.filter(name => name !== productName)
        : [...prev, productName]
    );
  };
  const hasModifications = () =>{
    return !isEqual(modifiedProducts, ic_products);
  }
  const handleSelectAllFilters = (checked: boolean) => {
    setSelectedFilters(checked ? uniqueProductNames as string[] : []);
  };
  const handleStockModify = (productId: string, field: string, value: number, destinationShop: string, destination: string) => {
    console.log('destinationShop', destinationShop);
    setModifiedProducts(modifiedProducts.map(product => 
        product.id === productId 
            ? { ...product, [field]: value, destination_shop_id: destination === StockDestination.OtherShop ? destinationShop : undefined, has_been_consumed: !(destination === StockDestination.Trash), destination: destination }
            : product
    ));
};
const onShowModifications = () => {
  const diff = modifiedProducts.filter(product => 
    product.three_liter !== ic_products.find(p => p.id === product.id).three_liter ||
    product.five_liter !== ic_products.find(p => p.id === product.id).five_liter ||
    product.seven_liter !== ic_products.find(p => p.id === product.id).seven_liter
  );
  console.log('diff', diff);
  dispatch(updateICProductsByShopBulk(selectedShop, diff));
}
  return (
    <div className='stock-management'>
      <div className="stock-management__header">
        <PageHierarchy />
        {isMobile && (
          <>
            <Dropdown 
              value={selectedShopObject}
              onChange={(e) => dispatch(setSelectedShop(e.value.id))}
              options={user.shops} 
              optionLabel="name" 
              placeholder="Select a shop"
              className="mobile-shop-selector"
              valueTemplate={shopTemplate}
              itemTemplate={shopTemplate}
            />
            <UpperControls
              search={search}
              setSearch={setSearch}
              showFilters={showFilters}
              setShowFilters={setShowFilters}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              handleFilterToggle={handleFilterToggle}
              handleSelectAllFilters={handleSelectAllFilters}
              uniqueProductNames={uniqueProductNames as string[]}
              onShowModifications={onShowModifications}
              hasModifications={hasModifications}
            />
          </>
        )}
      </div>
      {ic_products.length > 0 ? (
        <>
          {!isMobile && <AmrMeterGroup values={meterGroupValues} />}
          <StockTable 
            setNewFlavorsPopup={setIsPopupOpen}
            setProductIdToDelete={setProductIdToDelete}
            setWordToConfirm={setWordToConfirm}
            setProductToEdit={setProductToEdit}
            showUpperControls={!isMobile}
            search={search}
            setSearch={setSearch}
            showFilters={showFilters}
            setShowFilters={setShowFilters}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            handleStockModify={handleStockModify}
            modifiedProducts={modifiedProducts}
            hasModifications={hasModifications}
            onShowModifications={onShowModifications}
          />
          {(isPopupOpen || productToEdit) && (
            <NewFlavorsPopup fullCommentary="fff" isVisible={isPopupOpen || !!productToEdit} setVisible={setIsPopupOpen} productToEdit={productToEdit} setProductToEdit={setProductToEdit} />
          )}
          {wordToConfirm && productIdToDelete && 
            <ConfirmationPopup
              wordToConfirm={wordToConfirm}
              setWordToConfirm={setWordToConfirm}
              actionText='Are you sure you want to delete this product ?'
              actionDetail='This action is not recovarable'
              fncOnConfirm={deleteICProductsByShop}
              fncArgs={{shopId:selectedShop, productId:productIdToDelete}}
              />
          }
        </>
      ) : (
        <div className="stock-management__no-data">
          <p>No inventory data available. Please select or add a shop first to manage your products.</p>
          <Button 
              label="Go to Shop Management" 
              onClick={() => window.location.href = '/other/shop-management'}
              className="p-button-link"
          />
        </div>
      )}
    </div>
  );
};

export default StockManagement;
